import axios from 'axios';
import router from "../../router";

const state = {
  login: [],
};
const getters = {
  login(state) {
    return state.login;
  },
};
const mutations = {
  SET_LOGIN(state, payload) {
    state.login = payload;
  },
};
const actions = {
  addUser({commit}, payload){
    axios.post('https://api.geomalaka.uz/api/token/', payload)
      .then((res)=>{
        localStorage.setItem("access_token", 'Bearer ' + res.data.access);
        axios.defaults.headers.common["Authorization"] = "Bearer " + res.data.access;
        router.push("/");
        commit("SET_LOGIN", res.data.access)
      })
      .catch((error)=>{this._vm.$toast(error.message, {type: 'error'});})
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
